import { RouteItem } from '@eastcoal/router/types/route'

import {
  SECRET_AUCTION_CREATE_PAGE_PATH,
  SECRET_AUCTION_LIST_PAGE_PATH
} from './constants/path'
import { SECRET_AUCTION_LIST_PAGE_UUID } from './constants/uuid'

export const secretAuctionRoute: RouteItem = {
  title: '密函',
  hideChildrenInMenu: true,
  uuid: SECRET_AUCTION_LIST_PAGE_UUID,
  children: [
    {
      title: '密函列表',
      path: SECRET_AUCTION_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '新增密函',
      path: SECRET_AUCTION_CREATE_PAGE_PATH,
      Component: () => import('./Create')
    }
  ]
}
